import React, {Component} from 'react';
import Styles from './style.css';
import {BrowserRouter, Switch, Route} from 'react-router-dom';
import Home from "../../pages/home/component";
import About from "../../pages/about/component";
import Register from "../../pages/register/component";
import ForgotPassword from "../../pages/forgotpassword/component";
import LoginPin from "../../pages/login-pin/component";
import Error from "../../pages/error/component";
import ResetPassword from "../../pages/resetpassword/component";
import {BeatLoader} from "react-spinners";
import {langRegister} from "../../services/langRegister";
import LoginNopin from "../../pages/login-nopin/component";
import Vip from "../../pages/vip/component";
import {dataRegister} from "../../services/dataRegister";
import ErrorHandler from "../error-handler/component";
import {salesChannelRegister} from "../../services/salesChannelRegister";
import ReactGA from "react-ga";
import ReactGA4 from 'react-ga4';
import ReactPixel from "react-facebook-pixel";

class RouterWrapper extends Component {

    constructor(props) {
        super(props);
        this.state = {
            isLoading: true
        }
    };

    componentWillMount() {
        this._setApiDomain();
    }

    _setApiDomain(){
        dataRegister.documentLocation().then((response) => {
            let environment = response.headers.get('APP_PRODUCTION');
            if(environment === "true"){
                dataRegister.setApiDomain("live");
                dataRegister.setDomain("adbop.com");
            }else if(environment === "local"){
                dataRegister.setApiDomain("local");
                dataRegister.setDomain("devadbop.com");
            }else{
                dataRegister.setApiDomain("dev");
                dataRegister.setDomain("devadbop.com");
            }
            this._setVariables();
        }, (error) => {
            dataRegister.setApiDomain("dev");
            dataRegister.setDomain("devadbop.com");
            this._setVariables();
        });
    }

    _updateTitle() {
        document.title = this._renderText("item_1");
    }

    _setVariables() {

        const markets = {
            ae: {
                en: true
            },
            se: {
                sv: true,
                en: true
            }
        };

        //CHECK IF MARKET EXIST
        if(this.props.match.params.market === "ae" || this.props.match.params.market === "se"){

            //CHECK IF LANG EXIST IN MARKET
            if(markets[this.props.match.params.market][this.props.match.params.lang]){


                this._updateData().then((response) => {
                    salesChannelRegister.set("name", "adbop");
                    salesChannelRegister.set("market", this.props.match.params.market);

                    langRegister.set(this.props.match.params.lang, true);
                    salesChannelRegister.set("market", this.props.match.params.market);

                    this._updateTitle();

                    if(response.available_channel){
                        salesChannelRegister.set('available_channels', JSON.stringify(response.available_channel));
                    }else{
                        salesChannelRegister.set('available_channels', JSON.stringify({fb: true, google: true, bing: true, instagram: true}));
                    }
                    if (response.name) {
                        salesChannelRegister.set("company_name", response.name);
                    }
                    if (response.logo) {
                        salesChannelRegister.set('logo', response.logo);
                    }
                    if (response.logo_dashboard) {
                        salesChannelRegister.set('logo_dashboard', response.logo_dashboard);
                    }
                    if (response.logo_mobile) {
                        salesChannelRegister.set('logo_mobile', response.logo_mobile);
                    }
                    if(response.country_region){
                        salesChannelRegister.set('country_region', JSON.stringify(response.country_region));
                    }
                    if(response.default_language){
                        salesChannelRegister.set('default_language', response.default_language);
                    }
                    if(response.channels){
                        for(let i = 0; i < response.channels.length; i++){
                            if(response.channels[i] === "fb"){
                                response.channels[i] = "facebook";
                            }
                        }
                        salesChannelRegister.set('channels', JSON.stringify(response.channels));
                    }
                    if (response.currency) {
                        salesChannelRegister.set('currency', response.currency.toLowerCase());
                    }
                    if (response.from_email) {
                        salesChannelRegister.set('email', response.from_email);
                    }
                    if(response.campaign_duration){
                        salesChannelRegister.set('durations', JSON.stringify(response.campaign_duration));
                    }
                    if(response.default_campaign_duration) {
                        salesChannelRegister.set('default_duration', response.default_campaign_duration);
                    }
                    /*
                    if (response.ga_id && dataRegister.api.primehit !== "https://api.devprimehit.com/v1") {
                        ReactGA.initialize(response.ga_id);
                        salesChannelRegister.set('ga_id', response.ga_id);
                    }
                    if (response.ga4_id && dataRegister.api.primehit !== "https://api.devprimehit.com/v1") {
                        ReactGA4.initialize(response.ga4_id);
                        salesChannelRegister.set('ga4_id', response.ga4_id);
                    }
                    if (response.fb_id && dataRegister.api.primehit !== "https://api.devprimehit.com/v1") {
                        ReactPixel.init(response.fb_id);
                        salesChannelRegister.set('fb_id', response.fb_id);
                    }
                    /*/
                    if (dataRegister.api.primehit !== "https://api.devprimehit.com/v1") {
                        ReactGA.initialize('UA-133715853-1');
                        salesChannelRegister.set('ga_id', 'UA-133715853-1');
                        ReactGA4.initialize('G-WC2VNS108X');
                        salesChannelRegister.set('ga4_id', 'G-WC2VNS108X');
                    }
                    if (dataRegister.api.primehit !== "https://api.devprimehit.com/v1") {
                        ReactPixel.init('120964126779408');
                        salesChannelRegister.set('fb_id', '120964126779408');
                    }
                    if (response.vat) {
                        salesChannelRegister.set('vat', response.vat);
                    }else{
                        salesChannelRegister.set('vat', 0);
                    }
                    if (response.socialData) {
                        if (response.socialData.image && response.socialData.title !== "") {
                            salesChannelRegister.set('socialIcon', response.socialData.image);
                        }
                        if (response.socialData.title && response.socialData.title !== "") {
                            salesChannelRegister.set('socialIcon', response.socialData.title);
                        }
                        if (response.socialData.facebookID && response.socialData.facebookID !== "") {
                            salesChannelRegister.set('facebookID', response.socialData.facebookID);
                        }
                        if (response.socialData.instagramID && response.socialData.instagramID !== "") {
                            salesChannelRegister.set('instagramID', response.socialData.instagramID);
                        }
                    }

                    if (response.keyword_languages) {
                        salesChannelRegister.set('keyword_languages', JSON.stringify(response.keyword_languages));
                    }

                    //TEMP -> REMOVE LATER
                    if(this.props.match.params.market === "se") {
                        salesChannelRegister.set('ad_languages', JSON.stringify([{value: "sv", title: {en:"Swedish", sv:"Svenska"}}]));
                        salesChannelRegister.set('default_ad_language', "sv");
                    }else if(this.props.match.params.market === "ae"){
                        salesChannelRegister.set('ad_languages', JSON.stringify([{value: "en", title: {en:"English"}}]));
                        salesChannelRegister.set('default_ad_language', "en");
                    }

                    //TEMP -> REMOVE LATER
                    if(this.props.match.params.market === "se") {
                        salesChannelRegister.set('languages', JSON.stringify([{code: "sv", name: "Svenska", names: {sv: "Svenska", en: "Svenska"}}, {code: "en", name: "Engelska", names: {sv: "English", en: "English"}}]));
                    }else if(this.props.match.params.market === "ae"){
                        salesChannelRegister.set('languages', JSON.stringify([{code: "en", name: "English", names: {en: "English"}}]));
                    }

                    this.setState({error: false, isLoading: false});
                });


            }else{

                //GO TO SELECT LANGUAGE
                sessionStorage.clear();
                this.props.history.replace("/select-language");
                window.location.reload();
            }

        }else{

            //GO TO SELECT MARKET
            sessionStorage.clear();
            this.props.history.replace("/select-market");
            window.location.reload();

        }

    }

    async _updateData() {

        let data = await dataRegister.saleschannel(this.props.match.params.market, "adbop");
        return data;

    }

    _renderText(item) {
        return langRegister.get("router-wrapper", item);
    }

    render() {
        return (
            <div>
                {
                    !this.state.isLoading && !this.state.error &&
                    <switch>
                        <Route exact path={this.props.match.url} component={Home}/>
                        <Route exact path={this.props.match.url + "/scroll/:item"} component={Home}/>
                        <Route exact path={this.props.match.url + '/about'} component={About}/>
                        <Route exact path={this.props.match.url + '/vip'} component={Vip}/>
                        <Route path={this.props.match.url + '/error'} component={Error}/>
                    </switch>
                }
                {
                    this.state.isLoading && !this.state.error &&
                    <div className={Styles.loader}>
                        <BeatLoader size={30} color={'#41CBC7'} loading={true}/>
                    </div>
                }
                {
                    !this.state.isLoading && this.state.error &&
                    <div className={Styles.loader}>
                        <ErrorHandler/>
                    </div>
                }
            </div>
        );
    }

}

export default RouterWrapper


// WEBPACK FOOTER //
// ./src/components/router-wrapper/component.js